import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {DeletePostMutation} from "./__graphql-types__/DeletePostMutation.ts";

type DeletePostVariables = {
    postKey: string;
};

export const DELETE_POST_MUTATION: GqlOperation<
    DeletePostMutation,
    DeletePostVariables
> = gqlOp(gql`
    mutation DeletePostMutation($postKey: String!) {
        hideFeedback(feedbackKey: $postKey) {
            error {
                code
            }
        }
    }
`);
